export const anmClassificationCatalogEsES = {
  "sections": {
    "cri": {
      "label": "CRI",
      "subtitle": "1 - Clasificación de riesgo"
    },
    "dpa": {
      "label": "DPA",
      "subtitle": "2 - Daño potencial asociado"
    },
    "go": {
      "label": "Gestión operativa",
      "subtitle": "3 - Gestión operativa"
    }
  },
  "grades": {
    "ct": {
      "fullTitle": "1.1 - Características técnicas - CT"
    },
    "ec": {
      "fullTitle": "1.2 - Estado de conservación - EC"
    },
    "psb": {
      "fullTitle": "1.3 - Plan de seguridad de la presa - PSB"
    },
    "dpa": {
      "fullTitle": "2 - Clasificación según el daño potencial asociado - DPA (residuos y relaves)"
    },
    "go": {
      "fullTitle": "3 - Clasificación según la gestión operativa"
    }
  },
  "columns": {
    "ctA": {
      "title": "Altura"
    },
    "ctB": {
      "title": "Inclinación media de los taludes en la sección principal"
    },
    "ctC": {
      "title": "Longitud"
    },
    "ctD": {
      "title": "Caudal de diseño"
    },
    "ctE": {
      "title": "Control de compactación"
    },
    "ctF": {
      "title": "Existencia de drenaje interno"
    },
    "ctG": {
      "title": "Cimentación"
    },
    "ctH": {
      "title": "Método constructivo"
    },
    "ctI": {
      "title": "Instrumentación"
    },
    "ctJ": {
      "title": "Edad de la presa"
    },
    "ecK": {
      "title": "Confiabilidad de las estructuras de vertido"
    },
    "ecL": {
      "title": "Percolación"
    },
    "ecM": {
      "title": "Deformaciones y asentamientos"
    },
    "ecN": {
      "title": "Deterioro de taludes / paramentos"
    },
    "ecO": {
      "title": "Drenaje superficial"
    },
    "psbP": {
      "title": "Documentación de proyecto"
    },
    "psbQ": {
      "title": "Estructura organizativa y cualificación de los profesionales del equipo de seguridad de la presa"
    },
    "psbR": {
      "title": "Manuales de procedimientos para inspecciones de seguridad y monitoreo"
    },
    "psbS": {
      "title": "Plan de Acción de Emergencia PAE (cuando lo exija el órgano fiscalizador)"
    },
    "psbT": {
      "title": "Informes de inspección y monitoreo de la instrumentación y de análisis de seguridad"
    },
    "dpaA": {
      "title": "Volumen total del embalse"
    },
    "dpaB": {
      "title": "Existencia de población aguas abajo"
    },
    "dpaC": {
      "title": "Impacto ambiental"
    },
    "dpaD": {
      "title": "Impacto socioeconómico"
    },
    "goA": {
      "title": "Declaración de Condición de Estabilidad RISR enviada"
    },
    "goB": {
      "title": "Declaración de Condición de Estabilidad RPSB enviada"
    },
    "goC": {
      "title": "Declaración de Conformidad y Operatividad enviada"
    },
    "goD": {
      "title": "Extracto de Inspección enviado"
    },
    "goE": {
      "title": "Existencia de EdR"
    },
    "goF": {
      "title": "Programa de Gestión de Riesgos para Presas Mineras — PGRBM"
    },
    "goG": {
      "title": "Certificación y/o estándares de la industria"
    }
  },
  "options": {
    "ctA": {
      "score0": "Altura ≤ 15m",
      "score1": "15m < Altura < 30m",
      "score4": "30m ≤ Altura ≤ 60m",
      "score7": "Altura > 60m"
    },
    "ctB": {
      "score0": "Suave (≤ 1V:3H) o presa de concreto",
      "score3": "Intermedia (1V:2H ≥ Inclinación > 1V:3H)",
      "score6": "Empinada (> 1V:2H)"
    },
    "ctC": {
      "score0": "Longitud ≤ 50m",
      "score1": "50m < Longitud < 200m",
      "score2": "200 ≤ Longitud ≤ 600m",
      "score3": "Longitud > 600m"
    },
    "ctD": {
      "score0": "CMP (Crecida Máxima Probable) o decamilenaria",
      "score2": "Milenaria",
      "score5": "TR = 500 años",
      "score10": "TR inferior a 500 años o desconocida/ estudio no confiable"
    },
    "ctE": {
      "score0": "Existen documentos que comprueban el control de compactación conforme al proyecto y que comprueban el seguimiento y control tecnológico durante la ejecución",
      "score4": "Existen estudios geotécnicos que comprueban el grado de compactación de acuerdo con el proyecto",
      "score10": "No hubo control tecnológico y/o no hay información y/o la compactación está en desacuerdo con el proyecto"
    },
    "ctF": {
      "score0": "Drenaje construido conforme al proyecto o no existe drenaje en el proyecto",
      "score4": "Drenaje correctivo construido posteriormente a la conclusión de la presa",
      "score10": "Sistema de drenaje en desacuerdo con el proyecto, inexistente, desconocido, basado en estudio no confiable o inoperante"
    },
    "ctG": {
      "score0": "Cimentación investigada conforme al proyecto",
      "score6": "Cimentación parcialmente investigada",
      "score10": "Cimentación desconocida/estudio no confiable"
    },
    "ctH": {
      "score0": "Etapa única",
      "score2": "Elevación aguas abajo",
      "score5": "Elevación por línea central",
      "score10": "Elevación aguas arriba o desconocida"
    },
    "ctI": {
      "score0": "Existe instrumentación de acuerdo con el proyecto técnico",
      "score2": "Existe instrumentación en desacuerdo con el proyecto, pero está en proceso de instalación de instrumentos para adecuación al proyecto",
      "score6": "Existe instrumentación en desacuerdo con el proyecto sin proceso de instalación de instrumentos para adecuación al proyecto",
      "score8": "Presa no instrumentada en desacuerdo con el proyecto"
    },
    "ctJ": {
      "score1": "Entre 5 y 15 años",
      "score2": "Entre 15 y 30 años",
      "score3": "< 5 años o > 30 años o sin información"
    },
    "ecK": {
      "score0": "Estructuras civiles bien mantenidas y en operación normal /presa sin necesidad de estructuras de vertido",
      "score3": "Estructuras con problemas identificados y medidas correctivas en implementación",
      "score6": "Estructuras con problemas identificados y sin implementación de las medidas correctivas necesarias, sin restricción operativa y vertedero con capacidad plena",
      "score10": "Estructuras con problemas identificados, con reducción de capacidad de vertido y sin medidas correctivas"
    },
    "ecL": {
      "score0": "Percolación totalmente controlada por el sistema de drenaje",
      "score3": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes y estribos estables y monitoreados",
      "score6": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes o estribos sin implementación de las medidas correctivas necesarias",
      "score10": "Surgencia en las áreas aguas abajo con arrastre de material, caudal creciente o infiltración del material contenido, con potencial de comprometer la seguridad de la estructura"
    },
    "ecM": {
      "score0": "No existen deformaciones ni asentamientos con potencial de comprometer la seguridad de la estructura",
      "score2": "Existencia de grietas y hundimientos con medidas correctivas en implementación",
      "score6": "Existencia de grietas y hundimientos sin implementación de las medidas correctivas necesarias",
      "score10": "Existencia de grietas, hundimientos o deslizamientos, con potencial de comprometer la seguridad de la estructura"
    },
    "ecN": {
      "score0": "No existe deterioro de taludes y paramentos",
      "score2": "Fallas en la protección de taludes y paramentos, presencia de vegetación arbustiva",
      "score6": "Erosiones superficiales, armadura expuesta, presencia de vegetación arbórea, sin implementación de las medidas correctivas necesarias.",
      "score10": "Depresiones acentuadas en los taludes, deslizamientos, surcos profundos de erosión, con potencial de comprometer la seguridad de la estructura"
    },
    "ecO": {
      "score0": "Drenaje superficial existente y operativo",
      "score2": "Existencia de grietas y/o colmatación y/o hundimientos con medidas correctivas en implementación",
      "score4": "Existencia de grietas y/o colmatación y/o hundimientos sin medidas correctivas en implementación",
      "score5": "Drenaje superficial inexistente"
    },
    "psbP": {
      "score0": "Proyecto ejecutivo y \"as built\"",
      "score2": "Proyecto ejecutivo o \"as built\"",
      "score3": "Proyecto \"as is\"",
      "score5": "Proyecto básico",
      "score8": "Proyecto conceptual",
      "score10": "No hay documentación de proyecto"
    },
    "psbQ": {
      "score0": "Posee unidad administrativa con profesional técnico cualificado responsable de la seguridad de la presa, o es una presa no comprendida en los incisos I, II, III o IV del párrafo único del art. 1 de la Ley n.º 12.334/2010",
      "score1": "Posee profesional técnico cualificado (propio o contratado) responsable de la seguridad de la presa",
      "score3": "Posee unidad administrativa sin profesional técnico cualificado responsable de la seguridad de la presa",
      "score6": "No posee unidad administrativa ni responsable técnico cualificado por la seguridad de la presa"
    },
    "psbR": {
      "score0": "Posee manuales de procedimientos para inspección, monitoreo y operación, o es una presa no comprendida en los incisos I, II, III o IV del párrafo único del art. 1 de la Ley n.º 12.334/2010",
      "score2": "Posee solo manual de procedimientos de monitoreo",
      "score4": "Posee solo manual de procedimientos de inspección",
      "score8": "No posee manuales ni procedimientos formales para monitoreo e inspecciones"
    },
    "psbS": {
      "score0": "Posee PAE",
      "score2": "No posee PAE (no es exigido por el órgano fiscalizador)",
      "score4": "PAE en elaboración",
      "score8": "No posee PAE (cuando sea exigido por el órgano fiscalizador)"
    },
    "psbT": {
      "score0": "Emite regularmente informes de inspección y monitoreo basados en la instrumentación y de análisis de seguridad, o es una presa no comprendida en los incisos I, II, III o IV del párrafo único del art. 1 de la Ley n.º 12.334/2010",
      "score2": "Emite regularmente solo informes de análisis de seguridad",
      "score4": "Emite regularmente solo informes de inspección y monitoreo",
      "score6": "Emite regularmente solo informes de inspección visual",
      "score8": "No emite regularmente informes de inspección y monitoreo ni de análisis de seguridad"
    },
    "dpaA": {
      "score1": "Muy pequeño ≤ 500 mil m³",
      "score2": "Pequeño: 500 mil a 5 millones m³",
      "score3": "Mediano: 5 millones a 25 millones m³",
      "score4": "Grande: 25 millones a 50 millones m³",
      "score5": "Muy grande ≥ 50 millones m³"
    },
    "dpaB": {
      "score0": "INEXISTENTE — no existen personas permanentes/residentes o temporales/en tránsito en el área afectada aguas abajo de la presa",
      "score3": "POCO FRECUENTE — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe camino vecinal de uso local",
      "score5": "FRECUENTE — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera municipal o estatal o federal u otro lugar y/o emprendimiento de permanencia eventual de personas que podrán ser afectadas",
      "score10": "EXISTENTE — existen personas ocupando permanentemente el área afectada aguas abajo de la presa, por lo tanto, vidas humanas podrán ser afectadas"
    },
    "dpaC": {
      "score0": "INSIGNIFICANTE — el área afectada aguas abajo de la presa se encuentra totalmente descaracterizada de sus condiciones naturales y la estructura almacena solo residuos Clase II B - Inertes, según la NBR 10004 de la ABNT",
      "score2": "POCO SIGNIFICATIVO — el área afectada aguas abajo de la presa (no presenta área de interés ambiental relevante o áreas protegidas en legislación específica, excluidas las APP, y almacena solo residuos Clase II B - Inertes, según la NBR 10004 de la ABNT)",
      "score6": "SIGNIFICATIVO — el área afectada aguas abajo de la presa presenta área de interés ambiental relevante o áreas protegidas en legislación específica, excluidas las APP, y almacena solo residuos Clase II B - Inertes, según la NBR 10.004 de la ABNT",
      "score8": "MUY SIGNIFICATIVO — la presa almacena relaves o residuos sólidos clasificados en la Clase II A - No Inertes, según la NBR 10004 de la ABNT",
      "score10": "MUY SIGNIFICATIVO AGRAVADO — la presa almacena relaves o residuos sólidos clasificados en la Clase I - Peligrosos según la NBR 10.004 de la ABNT"
    },
    "dpaD": {
      "score0": "INEXISTENTE — no existen instalaciones en el área afectada aguas abajo de la presa",
      "score1": "BAJO — existe pequeña concentración de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómica cultural en el área afectada aguas abajo de la presa",
      "score3": "MEDIO — existe concentración moderada de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico cultural en el área afectada aguas abajo de la presa",
      "score5": "ALTO — existe alta concentración de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico cultural en el área afectada aguas abajo de la presa"
    },
    "goA": {
      "score0": "Atestando la estabilidad en los últimos 3 años",
      "score1": "Atestando la estabilidad durante el último semestre",
      "score8": "No atestando",
      "score10": "No enviada"
    },
    "goB": {
      "score0": "Atestando la estabilidad en los últimos 5 años",
      "score1": "Atestando la estabilidad referente a última enviada",
      "score8": "No atestando",
      "score10": "No enviada"
    },
    "goC": {
      "score0": "Atestando la conformidad en los últimos 3 años",
      "score1": "Atestando la conformidad durante el último año",
      "score8": "No atestando",
      "score10": "No enviada"
    },
    "goD": {
      "score0": "Dentro de los plazos legales y sin registro de anomalía puntuación 4, 6 o 10 en EC durante los últimos 2 años",
      "score1": "Dentro de los plazos legales y sin registro de anomalía puntuación 4, 6 o 10 en EC durante último semestre",
      "score2": "Fuera de los plazos legales o dentro de los plazos legales, pero con registro de anomalía puntuación 4, 6 o 10 en EC durante el último semestre",
      "score6": "Con pendientes de envío durante el último semestre",
      "score10": "No enviado más de 4 extractos subsecuentes o intercalados durante el último semestre"
    },
    "goE": {
      "score0": "Existe Ingeniero de Registro contratado",
      "score1": "No existe Ingeniero de Registro contratado (no es exigido por el órgano fiscalizador)",
      "score10": "No existe Ingeniero de Registro contratado (cuando sea exigido por el órgano fiscalizador)"
    },
    "goF": {
      "score0": "Posee PGRBM",
      "score1": "No posee PGRBM (no es exigido por el órgano fiscalizador)",
      "score4": "PGRBM en elaboración",
      "score9": "No posee PGRBM (cuando sea exigido por el órgano fiscalizador)"
    },
    "goG": {
      "score0": "Posee ISO 31.000 o adopta TSM o ICMM",
      "score1": "No posee ISO 31.000 o no adopta TSM o ICMM"
    }
  }
} as const;
